// extracted by mini-css-extract-plugin
export default {"home_bestfit_block":"S1_HmBestfit_home_bestfit_block__WT-jB","home_bestfit_desc":"S1_HmBestfit_home_bestfit_desc__40DYe"};